const initialState = {
  isloged: false,
  lang: "fr",
  logedType: "public",
  token: "",
  mode: "light",
  logged_at: new Date(Date.now()).toJSON(),
  data: [],
  provider: [],
};
const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case "data":
      return {
        ...state,
        data: {
          ...state?.data,
          ...action.payload,
        },
      };
    case "provider":
      return {
        ...state,
        provider: {
          ...state?.provider,
          ...action.payload,
        },
      };

    case "LOGGED_AT":
      return {
        ...state,
        logged_at: new Date(Date.now()).toJSON(),
      };

    case "LOGGED":
      return {
        ...state,
        isloged: action.payload,
      };

    case "LOGGEDTYPE":
      return {
        ...state,
        logedType: action.payload,
      };
    case "LANG":
      return {
        ...state,
        lang: action.payload,
      };
    case "MODE":
      return {
        ...state,
        mode: action.payload,
      };
    case "TOKEN":
      return {
        ...state,
        token: action.payload,
      };

    case "LOGOUT":
      return initialState;

    default:
      return state;
  }
};

export default profileReducer;
